export function getImageDimensionsBase64(base64) {
  return new Promise<{ w: number; h: number }>(function (resolved, rejected) {
    var i = new Image();
    i.onload = function () {
      resolved({ w: i.width, h: i.height });
    };
    i.src = base64;
  });
}
